import { render } from "./review.vue?vue&type=template&id=0662cd23&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"

import "./review.vue?vue&type=style&index=0&id=0662cd23&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0662cd23"

export default script